<section class="step" aria-labelledby="sb-sent-title">
  <!-- Always in the page; its text changes only at milestones (see announcement). -->
  <p class="bk-sr-only" role="status" aria-live="polite">{{ announcement() }}</p>

  <div class="bk-panel panel sent">
    <p class="bk-eyebrow">
      @switch (phase()) {
        @case ("done") {
          Sent
        }
        @case ("paused") {
          Still sending
        }
        @case ("unknown") {
          Sent to the server
        }
        @default {
          Sending
        }
      }
    </p>

    <h2 class="sent__title" id="sb-sent-title" tabindex="-1">
      @switch (phase()) {
        @case ("done") {
          All <strong>{{ formatCount(expected()) }}</strong> {{ expected() === 1 ? "message is" : "messages are" }}
          with the network.
        }
        @case ("paused") {
          <strong>{{ formatCount(submitted() ?? 0) }}</strong> of
          <strong>{{ formatCount(expected()) }}</strong> messages handed over so far.
        }
        @case ("unknown") {
          The server has your <strong>{{ formatCount(expected()) }}</strong> messages and is sending them.
        }
        @default {
          @if (submitted() === null) {
            Starting to send <strong>{{ formatCount(expected()) }}</strong>
            {{ expected() === 1 ? "message" : "messages" }}…
          } @else {
            <strong>{{ formatCount(submitted() ?? 0) }}</strong> of
            <strong>{{ formatCount(expected()) }}</strong> messages handed to the network.
          }
        }
      }
    </h2>

    @if (phase() !== "unknown") {
      <div
        class="bar"
        role="progressbar"
        aria-label="Messages handed to the network"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="expected()"
        [attr.aria-valuenow]="submitted() ?? 0"
      >
        <span class="bar__fill" [style.transform]="'scaleX(' + share() + ')'"></span>
      </div>

      @if (submitted() !== null) {
        <ul class="notes">
          @if (accepted() !== null) {
            <li class="note" data-tone="ok">
              <span>{{ formatCount(accepted() ?? 0) }} accepted by the network</span>
            </li>
          }
          @if (notAccepted()) {
            <li class="note" data-tone="bad">
              <span>
                {{ formatCount(notAccepted() ?? 0) }} not accepted
                <span class="note__more">The network refused these or gave no clear answer.</span>
              </span>
            </li>
          }
          @if (toGo() && phase() === "working") {
            <li class="note" data-tone="busy">
              <span>{{ formatCount(toGo()) }} still to go</span>
            </li>
          }
        </ul>
      }
    }

    <div class="sent__copy">
      @switch (phase()) {
        @case ("paused") {
          <p>
            No new messages for a couple of minutes. The server may still be working through the list. Check again,
            or look in Messages for “{{ sent()?.subject }}”.
          </p>
        }
        @case ("unknown") {
          <p>
            We can’t show progress right now. It sends one row at a time, so the messages appear in Messages over
            the next few minutes, each named “{{ sent()?.subject }}”.
          </p>
        }
        @case ("done") {
          <p>Each message is in Messages, named “{{ sent()?.subject }}”.</p>
        }
        @default {
          <p>
            The server sends one row at a time, so a long list takes a few minutes. You can leave this page; sending
            carries on.
          </p>
        }
      }
      <p class="sent__fine">
        Delivery receipts aren’t recorded for Custom SMS sends, so this shows what the network accepted, not what
        reached each phone.
      </p>
    </div>

    <div class="sent__actions">
      @if (phase() === "paused") {
        <button type="button" class="bk-btn bk-btn--ghost" (click)="checkAgain()">
          <span class="bk-sym" aria-hidden="true">refresh</span>
          Check again
        </button>
      }
      <a class="bk-btn bk-btn--ghost" routerLink="/organization/messages">
        View in Messages
        <span class="bk-sym trail" aria-hidden="true">arrow_outward</span>
      </a>
      <button type="button" class="bk-btn bk-btn--primary" (click)="restart.emit()">
        <span class="bk-sym" aria-hidden="true">add</span>
        Start another broadcast
      </button>
    </div>
  </div>
</section>
